import React from 'react'
import { useIntl } from 'react-intl'

import { ThemeButton, useModalContext } from '../../../../ui'
import { useSirContext } from '../../contexts'
import { CancelAppConfirmDialog } from '../dialogs'

export const CancelAppBtn = () => {
  const intl = useIntl()
  const {
    actions: { open },
  } = useModalContext()
  const { application, cancelApplication } = useSirContext()

  const handleCancel = () => {
    open({
      Component: CancelAppConfirmDialog,
      data: { application, cancelApplication },
    })
  }

  return (
    <ThemeButton color="default" onClick={handleCancel}>
      {intl.formatMessage({ id: 'pages.sir.detail.button.cancelApp.label' })}
    </ThemeButton>
  )
}
